import type {
    StaticDropdownDimensionConfiguration,
    StaticDropdownDimensionProps,
} from "../../components/dimensions/StaticDropdownDimension";
import { DimensionTypes } from "../../types/dimensions";

import type { DimensionFixtureExample } from ".";

export const staticDropdownDimensionConfiguration: Record<
    string,
    StaticDropdownDimensionConfiguration
> = {
    basic: {
        items: [
            { value: "1", label: "one" },
            { value: "2", label: "two" },
            { value: "3", label: "three" },
        ],
        label: "basic staticDropdown",
    },
};

export const staticDropdownDimensions: Record<
    string,
    StaticDropdownDimensionProps
> = {
    basic: {
        id: "static-dropdown-basic",
        type: DimensionTypes.STATIC_DROPDOWN,
        configuration: staticDropdownDimensionConfiguration.basic,
        dependencies: [],
        optional: false,
    },
    requestParameter: {
        id: "static-dropdown-rq",
        type: DimensionTypes.STATIC_DROPDOWN,
        configuration: {
            ...staticDropdownDimensionConfiguration.basic,
            label: "static dropdown request parameter remapped",
        },
        requestParameterMap: {
            value: "remapped_id",
            label: "remapped_name",
        },
        dependencies: [],
        optional: false,
    },
};

export const staticDropdownDimensionExamples: Record<
    string,
    DimensionFixtureExample
> = {
    basic: {
        id: "static-dropdown-basic",
        name: "staticDropdown dimension - basic",
        description: "basic staticDropdown dimension",
        dimensions: [[staticDropdownDimensions.basic]],
    },
    requestParameterMap: {
        id: "static-dropdown-rq",
        name: "staticDropdown dimension - requestParameter",
        description:
            "staticDropdown dimension showcasing how request parameter works",
        dimensions: [[staticDropdownDimensions.requestParameter]],
    },
    dependency: {
        id: "static-dropdown-dependency",
        name: "staticDropdown dependency",
        description: "staticDropdown dimension dependencies",
        dimensions: [
            [
                staticDropdownDimensions.requestParameter,
                {
                    ...staticDropdownDimensions.basic,
                    id: "second_dependency",
                    configuration: {
                        ...staticDropdownDimensionConfiguration.basic,
                        label: "2nd dependency",
                    },
                    dependencies: ["static-dropdown-rq"],
                },
                {
                    ...staticDropdownDimensions.basic,
                    id: "third_dependency",
                    configuration: {
                        ...staticDropdownDimensionConfiguration.basic,
                        label: "3rd dependency",
                    },
                    dependencies: ["static-dropdown-rq", "second_dependency"],
                },
                {
                    ...staticDropdownDimensions.basic,
                    id: "forth_dependency",
                    configuration: {
                        ...staticDropdownDimensionConfiguration.basic,
                        label: "fourth dependency",
                    },
                    dependencies: [
                        "static-dropdown-rq",
                        "second_dependency",
                        "third_dependency",
                    ],
                },
            ],
        ],
    },
};
